import React, { useState, useEffect } from "react";
import InputSearch from "./../../shared/components/input/InputSearch";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "./../../types/table/TableColumn";
import { Col, Container, Row } from "react-bootstrap";
import { RenderRowsCondominioGestaoCobranca } from "./RenderRowsCondominioGestaoCobranca";
import { Fade } from "@mui/material";
import { RequestCondominiosPaginados } from "types/request/RequestCondominiosPaginados";
import { useGetCondominiosPaginados } from "hooks/condominio/useGetCondominiosPaginados";

export const TabGestaoCobrancas: React.FC = () => {
  const [search, setSearch] = useState<string>("");
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("pessoaJuridica.nomeFantasia");
  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">();
  const [sortString, setSortString] = useState<string>("");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [mostrarConteudo, setMostrarConteudo] = useState<boolean>(false);
  const params = {
    size: 10,
    page: paginaAtual - 1,
    sort: sortString,
    nomeCondominio: search,
  } as RequestCondominiosPaginados;

  const { data: condominiosPaginados, isFetching } = useGetCondominiosPaginados(params);

  useEffect(() => {
    setMostrarConteudo(true);
  }, []);

  useEffect(() => {
    setPaginaAtual(1);
  }, [search]);

  const renderPesquisarCondominio = () => {
    return (
      <Col xs={6}>
        <InputSearch
          id="buscar-condominio-gestao-cobranca"
          label="Pesquisar"
          onSearchChange={setSearch}
          placeholder="Buscar pela Razão social, Nome fantasia/Apelido"
        />
      </Col>
    );
  };

  const renderTabelaCondominio = () => {
    return (
      <Col xs={12}>
        <Tabela
          id="tabela-condominio-gestao-cobranca"
          colunas={createColumns()}
          ordernarPorColuna={ordenarPorColuna}
          ordenacaoAscOuDesc={ordenacaoAscOuDesc}
          ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
          onChangePageFunction={(paginaAtual: number) => setPaginaAtual(paginaAtual)}
          paginaAtual={paginaAtual}
          quantidadeDePaginas={condominiosPaginados?.totalPages ?? 0}
          renderCheckBox={false}
          isLoading={isFetching}
          quantidadeDeRegistros={condominiosPaginados?.totalElements ?? 0}
        >
          <RenderRowsCondominioGestaoCobranca registros={condominiosPaginados?.content ?? []} />
        </Tabela>
      </Col>
    );
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao = !ordenacaoAscOuDesc || ordenacaoAscOuDesc === "DESC" ? "ASC" : "DESC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`${idColuna},${novaOrdenacao}`);
  };

  const createColumns = (): TableColumn[] => {
    return [
      {
        id: "pessoaJuridica.nomeFantasia",
        label: "Condomínio",
        isOrdenavel: true,
        width: "10vw",
      },
    ];
  };

  return (
    <>
      <Container>
        <Fade in={mostrarConteudo} timeout={700}>
          <div>
            <Row>{renderPesquisarCondominio()}</Row>
            <Row>{renderTabelaCondominio()}</Row>
          </div>
        </Fade>
      </Container>
    </>
  );
};
